<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>
      <p class="txt-tranf txt-center fonsize-20 magb20">
        <b
          >PHỤ LỤC<br />
          DỊCH VỤ MUA TRƯỚC TRẢ SAU "HOME PAY LATER"
        </b>
      </p>
      <p class="txt-center">
        (PLBNPL:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          <span>
            Hợp đồng hợp tác chấp nhận thanh toán số
            <mark>{{
              dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
            }}</mark>
          </span>
          <p class="magt10">
            (sau đây được viết tắt là “Hợp đồng”) ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>
              {{
                dataContract.effectiveFromDTO
                  ? dataContract.effectiveFromDTO
                  : dataContract.dateSign | formatDate
              }}</mark
            >
          </p>
        </li>
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="flex fonsize-16 txt-tranf">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD: <b>{{ dataContract.saleInfoRes.name ? dataContract.saleInfoRes.name : '' }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{ dataContract.saleInfoRes.mobile ? dataContract.saleInfoRes.mobile : '' }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="flex fonsize-16 txt-tranf">
        <span class="nowrap"> <b>BÊN B:</b></span>
        <mark>
          <b>{{ customerInfo.merchantName }}</b>
        </mark>
      </p>

      <div class="form form-ext">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}, {{ customerInfo.district }},
            {{ customerInfo.city }}
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Fax: </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p>
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>
      <ol class="form-style1">
        <li>
          <h1>NỘI DUNG HỢP TÁC</h1>
          <ul>
            <li>
              <b>Định nghĩa dịch vụ: Dịch vụ “Buy Now Pay Later – Mua trước trả sau”</b>(sau đây gọi
              tắt là dịch vụ <b>“BNPL”</b>)là một dịch vụ tài chính tín dụng do Công ty Tài chính
              TNHH MTV Home Credit Việt Nam (viết tắt là Công ty Home Credit Việt Nam) hợp tác cùng
              Bên A, cho phép Khách hàng của Bên B sử dụng dịch vụ BNPL để thanh toán Hàng hoá/ dịch
              vụ cho Bên B.
            </li>
            <li>b. Nội dung hợp tác:</li>
            <p>
              - Bên B đồng ý sử dụng Dịch vụ BNPL của Công ty Home Credit Việt Nam thông qua Bên A
              cung cấp, cho phép Khách hàng của Bên B có thể sử dụng dịch vụ BNPL để thanh toán Hàng
              hóa/ dịch vụ cho Bên B và đồng ý trả chi phí sử dụng dịch vụ này cho Công ty Home
              Credit Việt Nam và Bên A như được quy định cụ thể tại Điều 5. Phí dịch vụ của Phụ lục
              Hợp đồng này.
            </p>
          </ul>
        </li>
        <li>
          <h1>NGUYÊN TẮC CHẤP NHẬN SỬ DỤNG DỊCH VỤ BNPL</h1>
          <ol>
            <li>
              <span class="text-bold"
                >Bên B chỉ được sử dụng dịch vụ BNPL của Công ty Home Credit Việt Nam thông qua Bên
                A khi Bên B thỏa mãn các điều kiện sau:</span
              >
              <ul>
                <li>
                  Bên B chỉ thực hiện các hoạt động kinh doanh hàng hóa trong nước (không hỗ trợ các
                  giao dịch có hàng hóa được vận chuyển từ nước ngoài, có thời gian giao hàng hơn 1
                  tuần)
                </li>
                <li>
                  Bên B không vi phạm hoặc có phát sinh các hoạt động liên quan đến các ngành nghề
                  cấm của Công ty Home Credit Việt Nam như sau:
                  <p>+ Vàng, trang sức</p>
                  <p>+ Các tài sản/ sản phẩm/ dịch vụ có tính thanh khoản cao:</p>
                  <p>● Phiếu giảm giá, phiếu quà tặng</p>
                  <p>● Thẻ điện thoại/ Các loại thẻ nạp tiền khác</p>
                  <p>● Vé số</p>
                  <p>● Các loại tiền tệ, ngoại tệ</p>
                  <p>
                    ● Tất cả các loại tiền kỹ thuật số/ Các tài sản sử dụng Mã không thay thế (NFT)
                  </p>
                </li>
                <li>
                  Doanh nghiệp của Bên B ở tình trạng còn hoạt động khi tra thông tin trên các cổng
                  quốc gia về doanh nghiệp, hộ kinh doanh.
                </li>
                <li>
                  Bên B đã hoạt động kinh doanh ít nhất 06 (sáu) tháng kể từ ngày thành lập hợp pháp
                  theo giấy chứng nhận đăng ký kinh doanh của Bên B hoặc Bên B đã ký kết Hợp đồng
                  hợp tác chấp nhận thanh toán và sử dụng ít nhất 01 (một) dịch vụ do Bên A cung cấp
                  trước đó ít nhất 03 (ba) tháng.
                </li>
                <li>Doanh số bán hàng của Bên B ước tính từ 30 triệu đồng/tháng trở lên.</li>
                <li>
                  Bên B có địa chỉ kinh doanh khớp trên giấy Đăng ký doanh nghiệp/Hộ kinh doanh và
                  cổng thông tin quốc gia
                </li>
              </ul>
            </li>
            <li>
              <span class="text-bold"
                >Nếu Bên B có bất kỳ sự thay đổi nào về lĩnh vực kinh doanh, Bên B phải có nghĩa vụ
                thông báo bằng văn bản hoặc các hình thức khác với Bên A trước 15 (mười lăm) ngày kể
                từ ngày kể từ ngày có sự thay đổi.</span
              >
            </li>
            <li>
              <span class="text-bold"
                >Bên B chỉ được sử dụng dịch vụ BNPL của Công ty Home Credit Việt Nam thông qua Bên
                A để Khách hàng của Bên B thanh toán Hàng hoá/ dịch vụ cho Bên B mà không được phép
                cung cấp dịch vụ này cho một Bên khác hoặc nhận thanh toán hộ cho một Bên
                khác;</span
              >
            </li>
            <li>
              <span class="text-bold"
                >Khi Bên B có phát sinh bất cứ vấn đề về uy tín thương hiệu, bê bối, vấn đề phá sản
                và bất kỳ vấn đề nào khác mà Bên A và Công ty Home Credit Việt Nam cho là có bất kỳ
                tác động bất lợi nào liên quan đến thương hiệu của Bên A và Công ty Home Credit Việt
                Nam, Bên A có toàn quyền chấm dứt hợp tác dịch vụ BNPL với Bên B. Bên A sẽ chính
                thức ngừng cung cấp dịch vụ đến Bên B trong vòng 02 (hai) ngày sau khi Bên A đã gửi
                thông báo chính thức về việc chấm dứt hợp tác với Bên B.</span
              >
            </li>
            <li>
              <span class="text-bold"
                >Giá trị giao dịch BNPL là giá trị gốc của đơn hàng bao gồm các chi phí liên quan
                nhưng không bao gồm các chương trình khuyến mãi/ khuyến mại. Giá trị tối thiểu và
                giá trị tối đa của giao dịch BNPL được quy định cụ thể tại điều 5 của Phụ lục hợp
                đồng này hoặc thay đổi theo quy định của Bên A và Công ty Home Credit Việt Nam trong
                từng thời kỳ. Khi có bất cứ thay đổi nào, Bên A sẽ tiến hành gửi thông báo cho Bên B
                trong vòng 07 (bảy) ngày làm việc bằng email trước khi áp dụng.</span
              >
            </li>
            <li>
              <span class="text-bold"
                >Chỉ có các giao dịch khách hàng đã thanh toán và được ghi nhận thành công trên hệ
                thống của Bên A cung cấp cho Bên B mới được tiến hành đối soát và thanh toán trả
                tiền cho Bên B.</span
              >
            </li>
            <li>
              <span class="text-bold"
                >Quy trình và điều kiện thực hiện dịch vụ BNPL được áp dụng theo quy định của Bên A
                và Công ty Home Credit Việt Nam qua từng thời kỳ.</span
              >
            </li>
          </ol>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN A</h1>
          <ul>
            <li>
              Quảng bá về dịch vụ BNPL cho các khách hàng thông qua các phương tiện truyền thông của
              Bên A hoặc phối hợp với các đối tác cung cấp dịch vụ của Bên A để truyền thông quảng
              bá dịch vụ và các chương trình ưu đãi liên quan (nếu có) đến các tập khách hàng phù
              hợp để biết đến dịch vụ này tại các địa điểm kinh doanh, các kênh phân phối/cửa
              hàng/trụ sở của Bên B.
            </li>
            <li>Hỗ trợ giải đáp các thắc mắc theo yêu cầu của Khách hàng hoặc Bên B.</li>
            <li>
              Phối hợp với các đối tác cung cấp dịch vụ để giải đáp và thực hiện đúng quyền lợi của
              Khách hàng khi thực hiện giao dịch BNPL tại các điểm kinh doanh của Bên B.
            </li>
            <li>
              Bên A có quyền nêu tên Bên B trong các chiến dịch quảng bá chương trình có nội dung
              phù hợp với loại hình kinh doanh của Bên B mà Bên A có thể thực hiện trong thời hạn
              của Hợp đồng.
            </li>
            <li>
              Được quyền kiểm tra việc thực hiện Hợp đồng của Bên B, nếu Bên B thực hiện không đúng
              hoặc từ chối không thực hiện các nội dung của Hợp đồng vì bất kỳ lý do nào, bao gồm
              nhưng không giới hạn việc không chấp nhận hoặc từ chối hỗ trợ cho khách hàng sử dụng
              dịch vụ BNPL, các chế độ giao hàng và hậu mãi cho Khách hàng, các hành vi mang tính
              phân biệt đối xử khi thanh toán bằng BNPL thì Bên A có quyền: (1) ngay lập tức đơn
              phương chấm dứt Hợp đồng và yêu cầu bồi thường các thiệt hại thực tế phát sinh (bao
              gồm nhưng không giới hạn chi phí quảng cáo, marketing cho chương trình và chi phí
              thông báo trên báo giấy hoặc các phương tiện thông tin khác để thông báo về việc chấm
              dứt chương trình); và (3) hoàn lại cho khách hàng khoản tiền tương đương với giá trị
              của hình thức ưu đãi mà khách hàng đáng lẽ đã được nhận bằng tiền mặt hoặc quà tặng
              kèm theo (nếu có).
            </li>
            <li>
              Từ chối thực hiện quảng cáo cho Bên B nếu Bên B không tuân thủ các quy định tại Hợp
              đồng này hoặc vi phạm các quy định của pháp luật.
            </li>
            <li>
              Đảm bảo bí mật các thông tin về Bên B, chỉ được phép tiết lộ thông tin khi có yêu cầu
              của cơ quan chức năng theo quy định của pháp luật và phải thông báo cho Bên B về nội
              dung thông tin được tiết lộ.
            </li>
            <li>
              Thanh toán đầy đủ và đúng hạn các giao dịch hợp lệ phát sinh tại Bên B theo quy định
              tại Hợp đồng.
            </li>
            <li>Giải quyết các yêu cầu tra soát, khiếu nại của Bên B</li>
            <li>
              Bên A có quyền tạm hoãn, từ chối thanh toán hoặc thu hồi một phần, toàn bộ giao dịch
              đã thanh toán cho Bên B trong các trường hợp:
              <ul class="form-style2">
                <li>
                  Giao dịch là gian lận, giả mạo hoặc bị Chủ thẻ khiếu nại là gian lận, giả mạo hoặc
                  giao dịch nghi ngờ là gian lận, giả mạo theo thông báo của Tổ chức thẻ quốc tế.
                </li>
                <li>
                  Giao dịch không được Bên A thông báo cho Bên B là thành công hoặc giao dịch được
                  Bên A báo có trùng lặp.
                </li>
                <li>
                  Giao dịch bị khiếu nại và Bên B không thể cung cấp đầy đủ và đúng hạn chứng từ để
                  chứng minh giao dịch hoặc cung cấp chứng từ giả mạo.
                </li>
                <li>
                  Bên B không tuân thủ việc cung cấp thông tin, dữ liệu cho Bên A theo đúng quy định
                  của Hợp đồng.
                </li>
                <li>
                  Giao dịch sai lệch phát sinh do lỗi kỹ thuật của Bên B trong trường hợp Bên B có
                  kết nối kỹ thuật với Bên A.
                </li>
                <li>Việc cung cấp hàng hoá/dịch vụ giữa Bên B và Khách hàng vi phạm pháp luật.</li>
                <li>
                  Bên B không tuân thủ các điều khoản, điều kiện của Hợp đồng cũng như các quy định
                  khác bằng văn bản của Bên A.
                </li>
              </ul>
            </li>
            <li>
              Quyền đòi bồi hoàn của Bên A có thể kéo dài và giữ nguyên giá trị hiệu lực ngay cả khi
              Hợp đồng đã chấm dứt.
            </li>
            <li>
              Trong trường hợp Bên A nghi ngờ giao dịch của Bên B là gian lận, giả mạo, Bên A có
              quyền tạm ngừng thanh toán giá trị giao dịch bị nghi ngờ gian lận, giả mạo và yêu cầu
              Bên B cung cấp chứng từ để xác minh giao dịch.
            </li>
            <li>
              Bên A được quyền đơn phương chấm dứt/từ chối cung cấp dịch vụ mua trước trả sau Home
              Pay Later đối với Bên B và sẽ thông báo cho Bên B bằng văn bản trong trường hợp: Bên B
              vi phạm các quy định của Bên A theo Hợp đồng và Phụ lục liên quan đã kí kết giữa hai
              bên; Bên B vi phạm các quy định về rủi ro, nợ quá hạn, thuộc danh sách đơn vị vi phạm,
              ... của Nhà cung cấp dịch vụ; Bên B vi phạm quy định của pháp luật; hoặc có rủi ro/có
              khả năng gây tổn hại đến hình ảnh, uy tín của Bên A và Nhà cung cấp dịch vụ; hoặc Bên
              B bị phát hiện thông đồng với người mua thực hiện các giao dịch gian lận, giả mạo,
              giao dịch khống, giao dịch thuộc ngành cấm theo quy định của Nhà cung cấp dịch vụ
              và/hoặc Bên A.
            </li>
            <li>
              Các quyền và nghĩa vụ khác theo quy định của Hợp đồng này và quy định của pháp luật.
            </li>
          </ul>
        </li>
        <li>
          <h1>QUYỀN VÀ TRÁCH NHIỆM CỦA BÊN B</h1>
          <ul>
            <li>
              Bên B cam kết tuân thủ các chính sách, quy định, quy trình sử dụng dịch vụ BNPL trên
              ứng dụng hoặc website của Bên A để đảm bảo quyền lợi cho Khách hàng. Trường hợp Bên B
              không thực hiện lựa chọn dịch vụ BNPL trên ứng dụng của Bên A cho Khách hàng theo yêu
              cầu, giao dịch đó không được coi là giao dịch hợp lệ và Bên B phải chịu trách nhiệm
              đền bù chi phí phát sinh do không ghi nhận giao dịch cho Khách hàng
            </li>
            <li>
              Đồng ý thực hiện đầy đủ các quy trình thanh toán & chương trình ưu đãi liên quan (nếu
              có) cho khách hàng sử dụng dịch vụ BNPL như nội dung Hợp đồng.
            </li>
            <li>
              Giới thiệu dịch vụ BNPL đến khách hàng và thực hiện quảng cáo dịch vụ bằng một trong
              các phương tiện do Bên B quyết định.
            </li>
            <li>
              Hỗ trợ Bên A để dán các tài liệu quảng cáo tiếp thị về dịch vụ tại địa điểm kinh
              doanh, các kênh phân phối/cửa hàng/trụ sở của Bên B, các kênh phân phối/cửa hàng/trụ
              sở của Bên B để khách hàng biết đến dịch vụ này.
            </li>
            <li>
              Hợp tác với Bên A thực hiện các Chương trình dành cho khách hàng (nếu có) qua các thời
              kì theo đúng nội dung Hợp đồng và Phụ lục hợp đồng này.
            </li>
            <li>
              Cung cấp, đảm bảo tính trung thực và chịu trách nhiệm về nội dung, tính hợp pháp của
              các tài liệu tiếp thị cần thiết như logo, hình ảnh, các thông tin về Bên B, thông tin
              về sản phẩm được áp dụng dịch vụ BNPL để sử dụng trong việc truyền thông và quảng cáo
              cho dịch vụ của Bên A. Đảm bảo và chịu trách nhiệm về quyền sở hữu trí tuệ về logo,
              hình ảnh, sản phẩm khi cung cấp cho Bên A, đồng thời Bên B đồng ý và đảm bảo cho Bên A
              được quyền sử dụng để làm thiết kế, truyền thông.
            </li>
            <li>
              Chịu trách nhiệm hoàn toàn với khách hàng về những tranh chấp liên quan đến việc thực
              hiện thao tác dịch vụ BNPL, chương trình ưu đãi (nếu có), bao gồm nhưng không giới hạn
              các tranh chấp về việc Khách hàng không được sử dụng dịch vụ BNPL, không được hưởng
              các ưu đãi như thanh toán bằng tiền mặt; tranh chấp vì có sự phân biệt giá giữa các
              Khách hàng , yêu cầu Khách hàng trả thêm phụ phí đối với các giao dịch thanh toán tiền
              dịch vụ bằng thẻ so với thanh toán bằng tiền mặt…
            </li>
            <li>
              Tuân thủ theo thông báo và yêu cầu dừng dịch vụ của Bên A/Nhà cung cấp dịch vụ và chịu
              hoàn toàn trách nhiệm với việc: Bên B vi phạm quy định của Bên A; Bên B vi phạm các
              quy định về rủi ro, nợ quá hạn, thuộc danh sách đơn vị vi phạm…. của Nhà cung cấp dịch
              vụ; Bên B vi phạm quy định của pháp luật; hoặc có rủi ro/có khả năng gây tổn hại đến
              hình ảnh, uy tín của Bên A và Nhà cung cấp dịch vụ; hoặc phát hiện Bên B thông đồng
              với người mua thực hiện các giao dịch gian lận, giả mạo, giao dịch khống, giao dịch
              thuộc ngành cấm theo quy định của Nhà cung cấp dịch vụ và/hoặc Bên A.
            </li>
            <li>
              Bên B cam kết giải quyết trực tiếp với Khách hàng tất cả các thắc mắc, tranh chấp,
              khiếu nại về nghĩa vụ giao hàng hoá/dịch vụ và chất lượng hàng hoá/dịch vụ hoặc bất cứ
              vấn đề nào liên quan đến hàng hóa, dịch vụ do Bên B cung cấp cho Khách hàng.
            </li>
            <li>
              Mọi trường hợp sử dụng thông tin thuộc sở hữu hợp pháp của Bên A ngoài những nội dung
              đã thỏa thuận phải có ý kiến chấp thuận bằng văn bản của Bên A.
            </li>
            <li>
              Không yêu cầu Khách hàng tham gia dịch vụ BNPL thanh toán thêm bất kỳ khoản chi phí,
              phụ phí nào thông qua ứng dụng của Bên A.
            </li>
            <li>
              Đảm bảo việc cung cấp hàng hoá, dịch vụ trong phạm vi lãnh thổ Việt Nam là hợp pháp,
              tuân thủ quy định của Pháp luật; thực hiện đầy đủ các thủ tục xin cấp phép/thông
              báo/đăng ký trong quá trình hoạt động, kinh doanh với cơ quan nhà nước có thẩm quyền.
            </li>
            <li>
              Chịu trách nhiệm về tính hợp pháp của các hàng hoá, dịch vụ cung ứng trên website/ứng
              dụng thương mại điện tử và cam kết không thực hiện các giao dịch bị cấm hay các hành
              vi sử dụng dịch vụ thanh toán trực tuyến liên quan đến các giao dịch được coi là giao
              dịch bị cấm theo quy định của pháp luật Việt Nam hiện hành bao gồm nhưng không giới
              hạn vi phạm bản quyền, quảng cáo hoặc cho thuê quảng cáo các sản phẩm liên quan đến
              thuốc, marketing lừa đảo, thuốc kích thích, chất gây nghiện, vũ khí, hàng cấm, đánh
              bạc, khiêu dâm, tiết lộ thông tin khách hàng, các giao dịch nhằm mục đích rửa tiền,
              các mục đích bất hợp pháp khác. Trong trường hợp phát sinh các vi phạm tuân thủ liên
              quan đến hàng hóa, dịch vụ mà Bên B cung cấp, Bên B chịu hoàn toàn trách nhiệm với các
              vi phạm này theo quy định pháp luật hiện hành.
            </li>
            <li>
              Không được cấu kết với các tổ chức, cá nhân thực hiện các hành vi gian lận trong quá
              trình thanh toán, giao dịch thanh toán khống (không phát sinh việc mua bán hàng hóa,
              cung ứng dịch vụ); không được cung cấp, mua bán, trao đổi tiền ảo; không sử dụng dịch
              vụ mà Bên A cung cấp vào mục đích bất hợp pháp (bao gồm nhưng không giới hạn bởi các
              hành vi rửa tiền, tài trợ khủng bố, lừa đảo, đưa và nhận hối lộ, trốn thuế...). .
            </li>
            <li>
              Trong trường hợp nhận được yêu cầu cung cấp chứng từ của Bên A cho các giao dịch tra
              soát, khiếu nại, Bên B phải cung cấp đầy đủ chứng từ để chứng minh giao dịch là có
              thực và được thực hiện theo đúng yêu cầu cung cấp hàng hóa, dịch vụ giữa Bên B và
              Khách hàng trong vòng 04 (bốn) giờ làm việc kể từ ngày nhận được yêu cầu từ Bên A. Bên
              B phải chịu hoàn toàn trách nhiệm đối với các giao dịch này khi không thể cung cấp
              được chứng từ, cung cấp chứng từ chậm trễ và/hoặc cung cấp chứng từ giả mạo.
            </li>
            <li>
              Để phục vụ cho các tra soát khiếu nại đặc thù (nếu có), Bên B cam kết bảo quản, lưu
              giữ và cung cấp cho Bên A các thông tin dữ liệu liên quan đến các giao dịch của Khách
              hàng trong vòng 540 ngày kể từ ngày thực hiện giao dịch.
            </li>
            <li>
              Các quyền và nghĩa vụ khác theo quy định của Hợp đồng này và quy định của pháp luật.
            </li>
          </ul>
        </li>
        <li>
          <h1>PHÍ DỊCH VỤ</h1>
          <p><b>Phí xử lý giao dịch BNPL Bên B phải thanh toán cho Bên A:</b></p>
          <p>
            Phí xử lý giao dịch BNPL được tính trên cơ sở Tổng giá trị đơn hàng (bao gồm các chi phí
            liên quan nhưng không bao gồm các voucher khuyến mãi/khuyến mại) được Khách hàng đăng ký
            sử dụng dịch vụ này và giao dịch thành công, cụ thể như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>Tên kênh BNPL</b></th>
                  <th><b>Mức phí dịch vụ</b></th>
                  <th><b>Hạn mức giao dịch hợp lệ</b></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="txt-center">Home PayLater</td>
                  <td class="txt-center">2,9%</td>
                  <td class="txt-center">50.000 VNĐ – 25.000.000 VNĐ</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <i>Lưu ý</i>
            <ul class="form-style2">
              <li>Phí xử lý giao dịch BNPL đã bao gồm VAT</li>
              <li>
                Phí xử lý giao dịch có thể thay đổi theo biểu phí của Bên A và đối tác cung cấp dịch
                vụ của Bên A theo từng thời kỳ. Bên A có trách nhiệm thông báo cho bên B được biết
                về sự thay đổi này trước ít nhất 07 (bảy) ngày làm việc kể từ khi biểu phí mới được
                áp dụng thông qua email đầu mối liên hệ của Bên B được quy định tại Hợp đồng này.
                Trong vòng 07 ngày kể từ ngày nhận được thông báo, nếu bên B không có bất cứ phản
                hồi nào cho Bên A thì mức phí mới tự động được áp dụng.
              </li>
              <li>
                Bên B không được thực hiện hủy/đề nghị hoàn tiền cho user trong bất kỳ trường hợp
                nào.
              </li>
            </ul>
          </div>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết.
              Thời hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng
              nêu trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix ?? this.dataContract.lstAppendixHPLs.find(e => e.isCreatedWithContract)
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
